export default __webpack_public_path__ + "static/media/impage-cv.12b3af38.png";